// Santo Nhoque · Menu data extracted from real cardápio images
// Prices in BRL. R$ 1kg / R$ 500g

export const WHATSAPP_NUMBER = "5519982282824"; // (19) 98228-2824
export const WHATSAPP_DISPLAY = "(19) 98228-2824";
export const INSTAGRAM_URL = "https://instagram.com/santo.nhoque";
export const INSTAGRAM_HANDLE = "@santo.nhoque";

export const buildWhatsAppLink = (message) => {
  const text = encodeURIComponent(
    message ||
      "Olá Santo Nhoque! Gostaria de fazer um pedido das massas artesanais."
  );
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};

export const menuCategories = [
  {
    id: "nhoque",
    name: "Nhoque de Batata",
    tagline: "O clássico que dá nome à casa",
    description:
      "Batata fresca, farinha selecionada e o ponto certo da mão. Macio por dentro, dourado por fora.",
    image:
      "https://images.unsplash.com/photo-1579349443343-73da56a71a20?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    items: [
      { name: "Tradicional", desc: "A receita original, simples e perfeita.", price1kg: 27, price500g: 17 },
      { name: "Muçarela", desc: "Recheio cremoso de muçarela fresca.", price1kg: 34, price500g: 21 },
      { name: "Muçarela e Manjericão", desc: "Manjericão fresco e muçarela artesanal.", price1kg: 37, price500g: 23 },
      { name: "Provolone", desc: "Sabor marcante do provolone defumado.", price1kg: 38, price500g: 24 },
      { name: "Presunto e Muçarela", desc: "Combinação clássica e acolhedora.", price1kg: 38, price500g: 24 },
      { name: "Gorgonzola", desc: "Para quem ama sabores intensos.", price1kg: 40, price500g: 25 },
    ],
  },
  {
    id: "canelone",
    name: "Canelone",
    tagline: "Massa fina recheada com tradição",
    description:
      "Canelones recheados artesanalmente, prontos para gratinar com o seu molho preferido.",
    image:
      "https://images.pexels.com/photos/12409905/pexels-photo-12409905.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
    items: [
      { name: "Muçarela e Manjericão", desc: "Recheio aromático e cremoso.", price1kg: 52, price500g: 31 },
      { name: "Quatro Queijos", desc: "Muçarela, parmesão, provolone e gorgonzola.", price1kg: 62, price500g: 36 },
      { name: "Presunto e Muçarela", desc: "O sabor afetivo da nonna.", price1kg: 52, price500g: 31 },
    ],
  },
  {
    id: "rondelli",
    name: "Rondelli",
    tagline: "Rolinhos italianos recheados",
    description:
      "Rondellis frescos, enrolados à mão, com recheios delicados e equilibrados.",
    image:
      "/images/rondelli.png",
    items: [
      { name: "Muçarela e Manjericão", desc: "Frescor de manjericão em cada fatia.", price1kg: 52, price500g: 31 },
      { name: "Quatro Queijos", desc: "Combinação cremosa e marcante.", price1kg: 62, price500g: 36 },
      { name: "Presunto e Muçarela", desc: "Sabor italiano tradicional.", price1kg: 52, price500g: 31 },
      { name: "Muçarela com Tomate Seco", desc: "O agridoce do tomate seco italiano.", price1kg: 56, price500g: 33 },
      { name: "Muçarela com Tomate Seco e Rúcula", desc: "Pitada amarga da rúcula fresca.", price1kg: 60, price500g: 35 },
    ],
  },
  {
    id: "manicaretti",
    name: "Manicaretti",
    tagline: "A massa especial da casa",
    description:
      "Massas recheadas premium, com combinações nobres para ocasiões especiais.",
    image:
      "https://images.unsplash.com/photo-1611270629569-8b357cb88da9?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    items: [
      { name: "Ricota com Nozes", desc: "Suave, levemente adocicada, sofisticada.", price1kg: 66, price500g: null },
      { name: "Brie com Damasco", desc: "Brie cremoso e damasco em equilíbrio.", price1kg: 92, price500g: 51 },
      { name: "Búfala com Manjericão", desc: "Mussarela de búfala fresca + manjericão.", price1kg: 84, price500g: 47 },
    ],
  },
];

export const differentials = [
  {
    icon: "Wheat",
    title: "Produção Artesanal",
    desc: "Cada massa é feita à mão, na medida certa, sem pressa e sem atalhos.",
  },
  {
    icon: "ChefHat",
    title: "Receita Italiana",
    desc: "Tradição passada por gerações, fiel à origem das massas italianas.",
  },
  {
    icon: "Leaf",
    title: "Ingredientes Selecionados",
    desc: "Selecionamos os melhores ingredientes — frescos, locais e de qualidade.",
  },
  {
    icon: "Heart",
    title: "Feito com Amor",
    desc: "Desde 2015 servindo afeto em cada porção que sai da nossa cozinha.",
  },
];

export const testimonials = [
  {
    name: "Mariana Albuquerque",
    role: "Cliente desde 2018",
    text: "O nhoque de muçarela da Santo Nhoque virou tradição no almoço de domingo da minha família. Sabor de comida italiana de verdade.",
    rating: 5,
  },
  {
    name: "Roberto Salvatori",
    role: "Chef e amante de massas",
    text: "Como descendente de italianos, sou exigente com massa. O Manicaretti de Brie com Damasco é simplesmente espetacular.",
    rating: 5,
  },
  {
    name: "Carolina Bianchi",
    role: "Cliente fiel",
    text: "Atendimento impecável, massa fresquinha e o canelone gratinado fica perfeito no forno. Recomendo de olhos fechados.",
    rating: 5,
  },
  {
    name: "André Vieira",
    role: "Cliente recorrente",
    text: "Pedi para um jantar especial e meus convidados pediram bis. Qualidade muito acima de qualquer massa que eu já provei.",
    rating: 5,
  },
];

export const galleryImages = [
  {
    src: "https://images.unsplash.com/photo-1579349443343-73da56a71a20?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    alt: "Nhoque artesanal com molho de tomate",
    span: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1447279506476-3faec8071eee?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    alt: "Mãos amassando a massa fresca",
    span: "wide",
  },
  {
    src: "https://images.unsplash.com/photo-1551183053-bf91a1d81141?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    alt: "Massa fresca sendo preparada",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1546527276-0d0a6988a1aa?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    alt: "Manjericão e tomates frescos",
    span: "normal",
  },
  {
    src: "https://images.pexels.com/photos/12409905/pexels-photo-12409905.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900",
    alt: "Canelone gratinado com queijo",
    span: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1611270629569-8b357cb88da9?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    alt: "Massa recheada premium",
    span: "wide",
  },
  {
    src: "https://images.unsplash.com/photo-1473093295043-cdd812d0e601?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    alt: "Prato de massa servido",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1622973536968-3ead9e780960?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    alt: "Farinha e ingredientes na bancada",
    span: "normal",
  },
];

export const faqs = [
  {
    q: "Como faço para encomendar?",
    a: "Basta clicar em qualquer botão de WhatsApp do site. Você fala diretamente com a gente, escolhe os sabores, define a quantidade e combina retirada ou entrega.",
  },
  {
    q: "Qual o prazo de preparo?",
    a: "Nossas massas são feitas sob encomenda. Pedidos colocados com antecedência de 24 a 48h são preferenciais. Em alguns dias temos massas prontas para retirada imediata — pergunte pelo WhatsApp.",
  },
  {
    q: "As massas vêm prontas ou cruas?",
    a: "Entregamos as massas fresquinhas e pré-cozidas (no caso de canelone e rondelli) prontas para você gratinar no forno com seu molho favorito. O nhoque vai cru, pronto para cozinhar em água fervente — leva poucos minutos.",
  },
  {
    q: "Posso congelar a massa?",
    a: "Sim! Todas as nossas massas podem ser congeladas por até 90 dias mantendo sabor e textura. Recomendamos congelar logo após receber.",
  },
  {
    q: "Vocês entregam?",
    a: "Sim, fazemos entrega em região próxima sob taxa combinada. Também oferecemos retirada local. Detalhes pelo WhatsApp.",
  },
  {
    q: "Quais molhos vocês recomendam?",
    a: "Para o nhoque, recomendamos sugo de tomate fresco ou um molho ao bianco com manteiga e sálvia. Para canelone e rondelli, molho de tomate caseiro com parmesão gratinado. Temos dicas detalhadas no nosso Instagram.",
  },
];

export const howItWorks = [
  {
    step: "01",
    title: "Escolha seus sabores",
    desc: "Navegue pelo cardápio e selecione os pratos que vão à sua mesa.",
  },
  {
    step: "02",
    title: "Peça pelo WhatsApp",
    desc: "Fale direto com a gente. Você escolhe quantidade, data e forma de retirada.",
  },
  {
    step: "03",
    title: "Aproveite em casa",
    desc: "Receba sua massa fresca, prepare em minutos e desfrute do sabor da Itália.",
  },
];
